import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { listInvestmentsSummary } from "../../../redux/actions/investments";
import { getCommunityMetrics } from "../../../redux/actions/metrics";
import { getTrending } from "../../../redux/actions/trending";
import Card from "../../global/Card/Card";
import CommunityMetricsDistribution from "../../global/CommunityMetricsDistribution/CommunityMetricsDistribution";
import CreateInvestment from "../CreateInvestment/CreateInvestment";
import CreateNotifyModal from "../CreateNotifyModal/CreateNotifyModal";
import InvestmentDetails from "../InvestmentDetails/InvestmentDetails";
import InvestmentsTable from "../InvestmentsTable/InvestmentsTable";
import "./Investments.scss";

const Investments = () => {
  const [selectedContribution, setSeletedContribution] = useState(null);
  const [selectedContributionTasks, setSelectedContributionTasks] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [dataNotify, setDataNotify] = useState("");
  const investments = useSelector((state) => state.investments);
  const [openDetails, setOpenDetails] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const companyMetricsEngagement = useSelector((state) => state?.metrics);
  const communityMetrics = companyMetricsEngagement?.communityMetrics?.data;
  const metricsLoading = companyMetricsEngagement?.communityMetrics?.isFetching;

  const currentPage = parseInt(new URLSearchParams(location.search).get("page") || "1", 10);

  const onPageChange = (newPage) => {
    if (newPage !== currentPage) {
      history.push({ search: `?page=${newPage}` });
    }
  };
  const pageNumbers = Array.from(
    { length: investments?.data?.totalPages },
    (_, i) => i + 1
  );

  const formatValue = (val) => {
    if (val === undefined || val === null || val === -1) return "";
    let normalizedValue;
    if (val > 10) {
      normalizedValue = val / 100;
    } else {
      normalizedValue = val;
    }

    return normalizedValue.toFixed(1);
  };

  useEffect(() => {
    dispatch(listInvestmentsSummary({ page: currentPage }));
  }, [dispatch, currentPage]);

  useEffect(() => {
    dispatch(getTrending());
    dispatch(getCommunityMetrics());
  }, [dispatch]);

  useEffect(() => {
    if (showModal || showNotifyModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    if (!openDetails) {
      setSeletedContribution(null);
    }
  }, [showModal, showNotifyModal, openDetails]);

  const handleShowInvestmentModal = (contribution) => {
    setDataNotify(contribution);
    setShowModal(false);
    setShowNotifyModal(true);
  };

  return (
    <div className="Investments">
      {/* <TrendingTopics /> */}
      <div className="info-investments">
        <h2>Investimentos</h2>
        <p className="investments">
          <strong>Os investimentos são as competências da equipe.</strong>
          &nbsp;O patrimônio de cada um é seu conhecimento. Cada colaborador
          seleciona os investimentos que possui ou deseja desenvolver e
          realiza uma auto-avaliação, atribuindo um valor de proficiência
          naquela competência.
        </p>
      </div>
      <div className="container-cards-investments">
        <Card title="Alocação de Carteira" className="card-alocation">
          {metricsLoading ? (
            <div className="card-loading">
              <span className="card-loading__dot" />
              <span className="card-loading__dot" />
              <span className="card-loading__dot" />
            </div>
          ) : (
            <CommunityMetricsDistribution
              community={communityMetrics}
              skill
            />
          )}
        </Card>
        <div className="values-investments">
          <Card className="card-value" container title="Maior valor">
            {metricsLoading ? (
              <div className="card-loading">
                <span className="card-loading__dot" />
                <span className="card-loading__dot" />
                <span className="card-loading__dot" />
              </div>
            ) : (
              <>
                <article>
                  <p>{communityMetrics?.topicWithHighestValue?.name || "—"}</p>
                  <p className="grade">
                    {formatValue(communityMetrics?.topicWithHighestValue?.tracking?.average)}
                  </p>
                </article>
              </>
            )}
          </Card>
          <Card className="card-value" container title="Menor valor">
            {metricsLoading ? (
              <div className="card-loading">
                <span className="card-loading__dot" />
                <span className="card-loading__dot" />
                <span className="card-loading__dot" />
              </div>
            ) : (
              <>
                <article>
                  <p>{communityMetrics?.topicWithLowestValue?.name || "—"}</p>
                  <p className="grade">
                    {formatValue(communityMetrics?.topicWithLowestValue?.tracking?.average)}
                  </p>
                </article>
              </>
            )}
          </Card>
        </div>
      </div>
      <div className="table-investments">
        <div className="infos-table">
          <h4>Investimentos da Comunidade</h4>
          <p className="number-investments">
            {investments?.data?.totalItems} competências
          </p>
        </div>
        <div className="container-table">
          <InvestmentsTable
            executions={investments.data?.items}
            fetching={investments.isFetching || !investments.data?.items?.every(e => e?.topic?.name)}
          />
        </div>
        <div className="container-buttons">
          {pageNumbers.map((pageNumber) => (
            <button
              key={pageNumber}
              onClick={() => onPageChange(pageNumber)}
              className={`button-pagination ${pageNumber === currentPage ? "active" : ""
                }`}
            >
              {pageNumber}
            </button>
          ))}
        </div>
      </div>

      {showModal && (
        <CreateInvestment
          showModal
          handleCloseDetails={() => setOpenDetails(false)}
          selectedContribution={selectedContribution}
          handleShowInvestmentModal={handleShowInvestmentModal}
          handleNotifyModal={() => setShowNotifyModal(true)}
          handleShowModal={() => setShowModal(false)}
        />
      )}

      {showNotifyModal && (
        <CreateNotifyModal
          showNotifyModal
          dataNotify={dataNotify}
          handleShowModal={() => setShowNotifyModal(false)}
        />
      )}

      {openDetails && (
        <InvestmentDetails
          edit
          topic
          setShowModal={setShowModal}
          investment={selectedContribution}
          investmentTasks={selectedContributionTasks}
          handleClose={() => {
            setOpenDetails(false)
            setSelectedContributionTasks(null)
          }}
        />
      )}
    </div>
  );
};

export default Investments;
